module.exports = __webpack_public_path__ + "img/landing_cathouse.d067ed99.jpg";